/**
 * 未回答状態のデフォルト値。
 */
export const defaultAnswers = {
    q1: undefined,
    q2: undefined,
    q3: undefined,
    q4: undefined,
    q5: { selected: [], otherText: "" },
    q6: { selected: [] },
    q7: { selected: undefined, results: [] },
    q8: { selected: [], otherText: "" },
    q9: undefined,
    q10: { selected: [] },
    q11: { selected: [], otherText: "" },
    q12: { selected: undefined, drugName: "", symptom: "" },
    q13: {
        selected: undefined,
        types: [],
        period: undefined,
        frequency: undefined,
    },
    q14: { selected: undefined, weeks: undefined },
};
